import { combineReducers } from '@reduxjs/toolkit'
import authUserReducer from 'presentation/redux/slices/authUserSlice'
import representativeReducer from 'presentation/redux/slices/representativeSlice'
import eventMovementsReducer from 'presentation/redux/slices/eventMovementsSlice'
import additionalSavingsReducer from 'presentation/redux/slices/additionalSavingsSlice'
import promotionReducer from 'presentation/redux/slices/promotionSlice'
import studentReducer from 'presentation/redux/slices/studentSlice'
import notificationsReducer from 'presentation/redux/slices/notificationSlice'
import destinationReducer from 'presentation/redux/slices/destinationSlice'
import packageReducer from 'presentation/redux/slices/packageSlice'

const rootReducer = combineReducers({
  authUser: authUserReducer,
  representative: representativeReducer,
  eventMovements: eventMovementsReducer,
  additionalSavings: additionalSavingsReducer,
  promotion: promotionReducer,
  student: studentReducer,
  notifications: notificationsReducer,
  destination: destinationReducer,
  package: packageReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
